import { render, staticRenderFns } from "./CrmTicketCreate.vue?vue&type=template&id=6bed3a06&scoped=true"
import script from "./CrmTicketCreate.vue?vue&type=script&lang=js"
export * from "./CrmTicketCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed3a06",
  null
  
)

export default component.exports